export function settingsBase(pathname) {
  const path = String(pathname || '');
  if (path.startsWith('/apps/tender/masters')) return '/apps/tender/masters';
  if (path.startsWith('/apps/tender')) return '/apps/tender/settings';
  return '/platform/settings';
}

export function rolesListPath(pathname) {
  const path = String(pathname || '');
  if (path.startsWith('/apps/tender')) return '/apps/tender/settings/roles';
  if (path.startsWith('/platform/settings')) return '/platform/settings/roles';
  if (path.startsWith('/platform/roles')) return '/platform/roles';
  return '/apps/tender/settings/roles';
}

export function usersListPath(pathname) {
  const path = String(pathname || '');
  if (path.startsWith('/apps/tender')) return '/apps/tender/settings/users';
  if (path.startsWith('/platform/settings')) return '/platform/settings/users';
  if (path.startsWith('/platform/users')) return '/platform/users';
  return '/apps/tender/settings/users';
}

export function dropdownRoot(pathname) {
  const path = String(pathname || '');
  if (path.includes('/masters/lists')) return '/apps/tender/masters/lists';
  return `${settingsBase(path)}/dropdowns`;
}
